import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && url.startsWith("/admin")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("tow-auth-expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function errorText(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.response ? fallback : "Network error. Check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return fallback;
}

export function formatPhone(e164) {
  const d = (e164 || "").replace(/\D/g, "").replace(/^1(?=\d{10}$)/, "");
  if (d.length !== 10) return e164 || "";
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function formatAddress(a) {
  if (!a) return "";
  return [a.street, a.city, [a.state, a.zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
}

export function mapsLink(a) {
  if (!a) return "";
  const dest = a.lat && a.lng ? `${a.lat},${a.lng}` : formatAddress(a);
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(dest)}`;
}

export function routeLink(from, to) {
  const f = from.lat && from.lng ? `${from.lat},${from.lng}` : formatAddress(from);
  const t = to.lat && to.lng ? `${to.lat},${to.lng}` : formatAddress(to);
  return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(f)}&destination=${encodeURIComponent(t)}`;
}
